export default __webpack_public_path__ + "static/media/muharram.742dd478.png";